import { useQuery } from '@tanstack/react-query';
import { StatusClustering } from '@/types/vorgang';
import { queryKeys } from './queryKeys';
import { useApiClient } from './useApiClient';

export type StatusClusteringScope = 'main' | 'archive' | 'full';

export const useStatusClustering = (scope: StatusClusteringScope = 'main') => {
  const { axiosInstance } = useApiClient();

  return useQuery<StatusClustering>({
    queryKey: [...queryKeys.vorgaenge.statusClustering(), scope] as const,
    queryFn: async () => {
      const response = await axiosInstance.get<{
        statusClustering: StatusClustering;
      }>('/vorgaenge-status-clustering', { params: { scope } });
      return response.data.statusClustering;
    },
    staleTime: 60000, // 1 minute - status clustering changes less frequently
    gcTime: 300000, // 5 minutes
  });
};
